import { useI18n } from '../i18n.client'
import { Image } from '@shopify/hydrogen'
import styles from '../../assets/scss/components/not-found.module.scss'

export const NotFound: React.FC = () => {
  const [i18n] = useI18n()

  return (
    <div className={styles.notFound}>
      <Image alt={i18n.translate('page-not-found-title')} height={433} src="/page-not-found.svg" width={146} />
      <div className={styles.description}>{i18n.translate('page-not-found-description')}</div>
      <a className={styles.paginationButton} href="/">
        {i18n.translate('homepage')}
      </a>
    </div>
  )
}
